import './App.css';

import { AppRouts } from './routs';

function App() {
  return (
    <div className="App">
      <AppRouts />
    </div>
  );
}

export default App;
